import React, { useState } from 'react';
import { supabase } from '../../../lib/supabase';

const NewNotificationModal = ({ onClose, onCreated, managers }) => {
  const [form, setForm] = useState({
    title: '',
    body: '',
    destinataire: 'admin',
    manager_id: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!form?.title?.trim() || !form?.body?.trim()) {
      setError('Titre et corps requis');
      return;
    }
    setSaving(true);
    setError('');

    let target_type = 'admin';
    let target_manager_id = null;

    if (form?.destinataire === 'manager' && form?.manager_id) {
      target_type = 'manager';
      target_manager_id = form?.manager_id;
    } else if (form?.destinataire === 'all_managers') {
      // Insert one notification per manager
      const inserts = managers?.map(m => ({
        title: form?.title,
        body: form?.body,
        type: 'manual',
        target_type: 'manager',
        target_manager_id: m?.id,
      }));
      if (inserts?.length > 0) {
        const { error: insertErr } = await supabase?.from('notifications')?.insert(inserts);
        if (insertErr) {
          setError(insertErr?.message);
          setSaving(false);
          return;
        }
      }
      setSaving(false);
      onCreated?.();
      onClose?.();
      return;
    }

    const { error: insertErr } = await supabase?.from('notifications')?.insert([{
      title: form?.title,
      body: form?.body,
      type: 'manual',
      target_type,
      target_manager_id,
    }]);

    if (insertErr) {
      setError(insertErr?.message);
    } else {
      onCreated?.();
      onClose?.();
    }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
      <div className="w-full max-w-md rounded-2xl border p-6 flex flex-col gap-5"
        style={{ backgroundColor: '#111111', borderColor: '#2a2a2a' }}>
        <div className="flex items-center justify-between">
          <h3 className="text-white font-bold text-lg" style={{ fontFamily: 'Sora, sans-serif' }}>
            Nouvelle notification
          </h3>
          <button onClick={onClose} className="text-white/40 hover:text-white/70 transition-colors">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className="flex flex-col gap-4">
          <div>
            <label className="text-white/60 text-xs mb-1.5 block" style={{ fontFamily: 'Inter, sans-serif' }}>Titre</label>
            <input
              value={form?.title}
              onChange={e => setForm(p => ({ ...p, title: e?.target?.value }))}
              placeholder="Titre de la notification"
              className="w-full px-3 py-2.5 rounded-lg text-base text-white outline-none border transition-colors"
              style={{
                backgroundColor: '#0d0d0d',
                borderColor: '#2a2a2a',
                fontFamily: 'Inter, sans-serif',
              }}
              onFocus={e => e.target.style.borderColor = 'var(--color-primary)'}
              onBlur={e => e.target.style.borderColor = '#2a2a2a'}
            />
          </div>

          <div>
            <label className="text-white/60 text-xs mb-1.5 block" style={{ fontFamily: 'Inter, sans-serif' }}>Corps</label>
            <textarea
              value={form?.body}
              onChange={e => setForm(p => ({ ...p, body: e?.target?.value }))}
              placeholder="Contenu de la notification..."
              rows={4}
              className="w-full px-3 py-2.5 rounded-lg text-base text-white outline-none border transition-colors resize-none"
              style={{
                backgroundColor: '#0d0d0d',
                borderColor: '#2a2a2a',
                fontFamily: 'Inter, sans-serif',
              }}
              onFocus={e => e.target.style.borderColor = 'var(--color-primary)'}
              onBlur={e => e.target.style.borderColor = '#2a2a2a'}
            />
          </div>

          <div>
            <label className="text-white/60 text-xs mb-1.5 block" style={{ fontFamily: 'Inter, sans-serif' }}>Destinataire</label>
            <select
              value={form?.destinataire}
              onChange={e => setForm(p => ({ ...p, destinataire: e?.target?.value, manager_id: '' }))}
              className="w-full px-3 py-2.5 rounded-lg text-base text-white outline-none border"
              style={{ backgroundColor: '#0d0d0d', borderColor: '#2a2a2a', fontFamily: 'Inter, sans-serif' }}
            >
              <option value="admin">Admin</option>
              <option value="manager">Manager spécifique</option>
              <option value="all_managers">Tous les managers</option>
            </select>
          </div>

          {form?.destinataire === 'manager' && (
            <div>
              <label className="text-white/60 text-xs mb-1.5 block" style={{ fontFamily: 'Inter, sans-serif' }}>Sélectionner un manager</label>
              <select
                value={form?.manager_id}
                onChange={e => setForm(p => ({ ...p, manager_id: e?.target?.value }))}
                className="w-full px-3 py-2.5 rounded-lg text-base text-white outline-none border"
                style={{ backgroundColor: '#0d0d0d', borderColor: '#2a2a2a', fontFamily: 'Inter, sans-serif' }}
              >
                <option value="">-- Choisir --</option>
                {managers?.map(m => (
                  <option key={m?.id} value={m?.id}>{m?.name || m?.email}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {error && (
          <p className="text-red-400 text-xs" style={{ fontFamily: 'Inter, sans-serif' }}>{error}</p>
        )}

        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg text-sm text-white/60 hover:text-white/80 transition-colors"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Annuler
          </button>
          <button
            onClick={handleSubmit}
            disabled={saving}
            className="px-5 py-2 rounded-lg text-sm font-semibold text-white transition-all"
            style={{
              backgroundColor: saving ? '#333' : '#E5202A',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {saving ? 'Envoi...' : 'Envoyer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewNotificationModal;
